import { scoreTextClass } from "../../utils/helpers/scoreColors";

export default function DonutProgress({
  score,
  size = 40,
  strokeWidth = 4,
  showLabel = true,
  labelSize = "text-[10px]",
}) {
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  // null = no data: empty slate arc with an em-dash label, never a red 0%.
  const offset = circumference - ((score ?? 0) / 100) * circumference;
  const colorClass = scoreTextClass(score);

  return (
    <div
      className="relative flex items-center justify-center"
      style={{ width: size, height: size }}
    >
      <svg width={size} height={size} className="transform -rotate-90">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="currentColor"
          strokeWidth={strokeWidth}
          fill="transparent"
          className="text-slate-100"
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="currentColor"
          strokeWidth={strokeWidth}
          fill="transparent"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          className={`transition-all duration-1000 ease-out ${colorClass}`}
        />
      </svg>
      {showLabel && (
        <span
          className={`absolute ${labelSize} font-mono font-black tracking-tighter ${colorClass}`}
        >
          {score == null ? "—" : `${score}%`}
        </span>
      )}
    </div>
  );
}
